import Cookies from "universal-cookie/lib";
import { getCookie } from "../../app/utils/getCookie";
import { setCookie } from "../../app/utils/setCookie";
import { isLocal } from "../../utils/envutil";

const cookies = new Cookies();
const get = (): string => {
	let sessionId = getCookie("session_id");
	if (sessionId !== undefined && sessionId) return sessionId;
	if (isLocal()) {
		const sessionIdStorage = localStorage.getItem("session_id");
		if (!sessionIdStorage) return "";
		return sessionIdStorage;
	}
	return "";
};
const update = (session?: string) => {
	if (session !== undefined) {
		let copiedSession = session.split("").join("");
		setCookie("session_id", copiedSession);
		if (isLocal()) {
			localStorage.setItem("session_id", copiedSession);
		}
	}
};
const remove = () => {
	cookies.remove("session_id", { path: "/" });
	// if(isLocal()){
	localStorage.removeItem("session_id");
	// }
};
export const SessionIdService = { get, update, remove };
export default SessionIdService;
